(function () {
    'use strict';

    /**
     * Contact us section - owns its social network links.
     * Used as an attribute on the server rendered <section> (Views/Events/_ContactUs.cshtml).
     * No template and a child scope, so the Razor markup inside binds to "contactUsSection"
     * and still sees the page "vm" (getStyle, showLoading).
     */
    angular
        .module('EventListApp')
        .directive('wsSectionContactUs', sectionContactUs);

    function sectionContactUs() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionContactUsCtrl,
            controllerAs: 'contactUsSection'
        };
    }

    SectionContactUsCtrl.$inject = ['$element', 'ApiFactory', 'SectionRegistry'];

    function SectionContactUsCtrl($element, ApiFactory, SectionRegistry) {
        const vm = this;
        vm.links = [];

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        /**
         * Load the contact us links of the page
         * @param {number} eventId
         * @param {number} lang
         * @param {object} pageData { pageId }
         * @returns {Promise}
         */
        function load(eventId, lang, pageData) {
            return ApiFactory.GetContactUSLinks(eventId, pageData.pageId).then(function (response) {
                vm.links = response.data;
            });
        }
    }
})();
